module.exports = __webpack_public_path__ + "static/media/logo.70b5506f.png";